import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Activity, Baby, TestTube, Eye, HeartPulse, Stethoscope, Syringe, Users, Calendar } from 'lucide-react';
import { ToothIcon } from '../icons/ToothIcon';
const TOP_SERVICES = [{
  title: 'General Consultations',
  icon: <Stethoscope className="w-7 h-7" data-id="element-184" data-mp="116m8fih1c78f" />,
  desc: 'Expert medical advice and treatment for common illnesses and health concerns.',
  slug: 'general-medical-consultations'
}, {
  title: 'Maternal Care',
  icon: <Baby className="w-7 h-7" data-id="element-185" data-mp="s7r4kd1gr98a" />,
  desc: 'Comprehensive antenatal and postnatal care for mothers and babies.',
  slug: 'antenatal-care'
}, {
  title: 'Laboratory Services',
  icon: <TestTube className="w-7 h-7" data-id="element-186" data-mp="i9l13r00dv1b" />,
  desc: 'Accurate and fast diagnostic testing including blood work and DNA testing.',
  slug: 'laboratory-services'
}, {
  title: 'Ultrasound & ECG',
  icon: <Activity className="w-7 h-7" data-id="element-187" data-mp="2clhye0l4tv4a" />,
  desc: 'Advanced imaging and heart monitoring for precise medical diagnosis.',
  slug: 'ultrasound-services'
}, {
  title: 'Chronic Disease',
  icon: <HeartPulse className="w-7 h-7" data-id="element-188" data-mp="1mvei44ffc0ch" />,
  desc: 'Ongoing management and support for diabetes, hypertension, and more.',
  slug: 'chronic-disease-management'
}, {
  title: 'Optician Services',
  icon: <Eye className="w-7 h-7" data-id="element-189" data-mp="1wnk858m487p1" />,
  desc: 'Professional eye examinations and vision care solutions.',
  slug: 'optician-services'
}, {
  title: 'Immunizations',
  icon: <Syringe className="w-7 h-7" data-id="element-190" data-mp="13y3lysp39n19" />,
  desc: 'Essential vaccines for children and adults to prevent infectious diseases.',
  slug: 'immunizations'
}, {
  title: 'Family Planning',
  icon: <Users className="w-7 h-7" data-id="element-191" data-mp="1dv86ko3adafy" />,
  desc: 'Confidential counseling and contraceptive services for family planning.',
  slug: 'family-planning'
}];
export function ServicesOverview() {
  return <section className="py-20 bg-brand-lighter" data-id="element-192" data-mp="2pboezxgfaqtb">
      <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-193" data-mp="2pczirx9vbykf">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-194" data-mp="1lyxx2izzy4pk">
          <div className="max-w-2xl" data-id="element-195" data-mp="1qy10y048q4vy">
            <span className="text-brand-red font-semibold tracking-wider text-sm uppercase mb-3 block" data-id="element-196" data-mp="1r16qthkp1asq">
              Our Services
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-navy mb-4" data-id="element-197" data-mp="2001y6wzh4qxm">
              Comprehensive Healthcare Solutions
            </h2>
            <p className="text-slate-600 text-lg" data-id="element-198" data-mp="137oku1yud1ua">
              We offer a wide range of medical services under one roof, ensuring
              you and your family receive complete care.
            </p>
          </div>
          <Link to="/services" className="inline-flex items-center gap-2 text-brand-navy font-semibold hover:text-brand-red transition-colors shrink-0" data-id="element-199" data-mp="1h0o0c3ymiw1u">
            View All Services <ArrowRight className="w-5 h-5" data-id="element-200" data-mp="ok3g63mbiuk9" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-201" data-mp="h13z44mbxf42">
          {TOP_SERVICES.map((service, idx) => <div key={idx} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-soft-lg transition-all duration-300 border border-slate-100 group relative overflow-hidden" data-id="element-202" data-mp="c1rd1m3a8c2j" data-mpi={idx}>
              <div className="absolute top-0 left-0 w-full h-1 bg-brand-red transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500 ease-out" data-id="element-203" data-mp="30jhhbs5hpc5" />

              <div className="w-14 h-14 bg-brand-light rounded-xl flex items-center justify-center mb-6 text-brand-gold group-hover:scale-110 transition-transform duration-300" data-id="element-204" data-mp="3pgno2rfywbdb">
                {service.icon}
              </div>

              <h3 className="text-xl font-heading font-bold text-brand-navy mb-3 group-hover:text-brand-red transition-colors" data-id="element-205" data-mp="3ghsi9ggu53aj">
                {service.title}
              </h3>

              <p className="text-slate-600 text-sm mb-6 line-clamp-2" data-id="element-206" data-mp="36j30dnoxviua">
                {service.desc}
              </p>

              <div className="flex items-center justify-between mt-auto pt-4 border-t border-slate-50" data-id="element-207" data-mp="1aff15k5w7ujy">
                <Link to={`/services/${service.slug}`} className="text-sm font-medium text-brand-navy hover:text-brand-red transition-colors" data-id="element-208" data-mp="1fd6rwausxamk">
                  Learn More
                </Link>
                <Link to={`/book?service=${service.slug}`} className="w-8 h-8 rounded-full bg-brand-lighter flex items-center justify-center text-brand-navy hover:bg-brand-red hover:text-white transition-colors" data-id="element-209" data-mp="rnw0hjzccsl3">
                  <ArrowRight className="w-4 h-4" data-id="element-210" data-mp="hsc3eu91jnur" />
                </Link>
              </div>
            </div>)}

          {/* Dentistry */}
          <div className="md:col-span-2 lg:col-span-4 bg-white rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-soft-lg transition-shadow duration-300 border border-slate-100 group relative overflow-hidden flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-10" data-id="element-211" data-mp="2c5aehg2keoj5">
            <div className="absolute top-0 left-0 w-full h-1 bg-brand-red transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500 ease-out" data-id="element-212" data-mp="gx8a90vm3yy" />

            <div className="flex items-start gap-5 flex-1" data-id="element-213" data-mp="f7wan2b4bwa3">
              <div className="w-14 h-14 bg-brand-light rounded-xl flex items-center justify-center text-brand-gold shrink-0 group-hover:scale-110 transition-transform duration-300" data-id="element-214" data-mp="ae1ta5izjte6">
                <ToothIcon className="w-7 h-7" data-id="element-215" data-mp="j7wrsuplqlku" />
              </div>
              <div data-id="element-216" data-mp="j9r8fwtubrj4">
                <h3 className="text-xl md:text-2xl font-heading font-bold text-brand-navy mb-2 group-hover:text-brand-red transition-colors" data-id="element-217" data-mp="y4e2rktvpy6v">
                  Dentistry
                </h3>
                <p className="text-slate-600 text-sm md:text-base max-w-xl" data-id="element-218" data-mp="2zvr2zwkwjhwl">
                  Comprehensive dental care focused on maintaining healthy
                  teeth, gums, and confident smiles.
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 shrink-0" data-id="element-219" data-mp="3kmwa4cipxjg3">
              <Link to="/services/dentistry" className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-brand-navy text-brand-navy text-sm font-semibold px-5 py-2.5 whitespace-nowrap hover:bg-brand-navy hover:text-white transition-colors" data-id="element-220" data-mp="3onpyf702p09i">
                View Dentistry Services <ArrowRight className="w-4 h-4" data-id="element-221" data-mp="7cgtiqnra1u9" />
              </Link>
              <Link to="/book?service=dentistry" className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-red text-white text-sm font-semibold px-5 py-2.5 whitespace-nowrap hover:bg-brand-navy transition-colors" data-id="element-222" data-mp="betvr53anhma">
                <Calendar className="w-4 h-4" data-id="element-223" data-mp="q63y38s7i2te" /> Book Appointment
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}